import React from 'react'
import { Button, TextField, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import SignupSubmitButton from './SignupSubmitButton'

interface CodeStepProps {
    email: string
    code: string
    codeLength: number
    onCodeChange: (value: string) => void
    errorMessage?: string
    submitting: boolean
    resendSecondsLeft: number
    onResend: () => void
}

const CodeStep: React.FC<CodeStepProps> = ({
    email,
    code,
    codeLength,
    onCodeChange,
    errorMessage,
    submitting,
    resendSecondsLeft,
    onResend,
}) => {
    const { t } = useTranslation()

    return (
        <>
            <Typography variant="body2" align="center">
                {t('signup.code_sent', { email })}
            </Typography>
            <TextField
                fullWidth
                // eslint-disable-next-line jsx-a11y/no-autofocus -- first field of a fresh step
                autoFocus
                label={t('signup.code_label')}
                value={code}
                autoComplete="one-time-code"
                slotProps={{ htmlInput: { inputMode: 'numeric', maxLength: codeLength } }}
                onChange={(e) => onCodeChange(e.target.value.replace(/\D/g, ''))}
                error={!!errorMessage}
                helperText={errorMessage}
            />
            <SignupSubmitButton disabled={submitting || code.length !== codeLength}>
                {t('signup.verify_code_button')}
            </SignupSubmitButton>
            <Button
                type="button"
                variant="text"
                disabled={submitting || resendSecondsLeft > 0}
                onClick={onResend}
                fullWidth
            >
                {resendSecondsLeft > 0
                    ? t('signup.resend_cooldown', { seconds: resendSecondsLeft })
                    : t('signup.resend_code')}
            </Button>
        </>
    )
}

export default CodeStep
